window.TinyMce = new function () {
    /**
     * Initialize tinymce
     */
    this.init = function (height = 200) {
        TinyMce.initLibrary(height);
        TinyMce.initLibraryPageBuilder(height);
        TinyMce.initLibraryBlank(100);
        TinyMce.initLibraryAdmin(height);

        jQuery('body').on('keyup', 'textarea', function (event) {
            if (jQuery(this).next('#character-count').length) {
                event.preventDefault();

                var max = 280;
                if (jQuery(this).next().attr('data-character-limit')) {
                    max = jQuery(this).next().attr('data-character-limit');
                }

                var count = jQuery(this).val().length;

                if (count >= max) {
                    if (event.keyCode != 8 && event.keyCode != 46) {
                        var str = jQuery(this).val();
                        var trimmed = str.substring(0, max);
                        jQuery(this).val(trimmed);
                    }

                    jQuery(this).next('#character-count').text("Maximum allowed characters is: " + max);
                } else {
                    jQuery(this).next('#character-count').text("Characters: " + count + ' (Max: ' + max + ')');
                }
            }
        });

        jQuery('body').on('keyup', 'input', function (event) {
            var max = 200;
            var limit = jQuery(this).attr('data-character-limit');
            var count = jQuery(this).val().length;

            if (typeof limit !== 'undefined' && limit !== false) {
                max = limit;
            }

            if (count >= max) {
                if (event.keyCode != 8 && event.keyCode != 46) {
                    var str = jQuery(this).val();
                    var trimmed = str.substring(0, max);
                    jQuery(this).val(trimmed);

                    jQuery(this).prev('p.red.character-limit-exceeded').remove();
                    jQuery(this).before('<p class="red character-limit-exceeded">You have exceeded the character limit and your text has been trimmed</p>');
                }
            } else {
                jQuery(this).prev('p.red.character-limit-exceeded').remove();
            }
        });
    };

    /**
     * Initial tinymce library
     *
     * @param int $height
     */
    this.initLibrary = function (height = 500) {
        tinymce.remove("textarea.tinymce-editor");

        // Prevent Bootstrap dialog from blocking focusin
        document.addEventListener('focusin', (e) => {
            if (e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });

        tinymce.init({
            selector: 'textarea.tinymce-editor',
            height: height,
            max_height: 700,
            media_alt_source: false,
            media_dimensions: false,
            convert_urls: false,
            relative_urls: false,
            remove_script_host: false,
            link_url_preprocess: function (url) {
                // If it doesn't already have a protocol or is not a relative/internal/anchor
                if (
                    url &&
                    !url.match(/^(https?:|mailto:|tel:|\/|#)/i) &&
                    !url.match(/^[a-z]+:/i)
                ) {
                    return 'https://' + url;
                }
                return url;
            },
            link_default_protocol: 'https',
            link_assume_external_targets: true,
            media_poster: false,
            resize: 'both',
            menubar: false,
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'charmap', 'anchor',
                'searchreplace', 'visualblocks', 'fullscreen',
                'insertdatetime', 'help', 'wordcount', 'media', 'autoresize'
            ],
            paste_as_text: true,
            toolbar: 'bold italic underline | link | bullist numlist',
            media_url_resolver: (data) => {
                return new Promise((resolve) => {
                    if (data.url.indexOf('youtube') !== -1) {
                        var vid_id = FunMain.getParameterByName('v', data.url);
                        var embedHtml = '<iframe src="https://www.youtube.com/embed/' + vid_id +
                            '" width="400" height="400" ></iframe>';
                        resolve({ html: embedHtml });
                    } else {
                        resolve({ html: '' });
                    }
                });
            },
            content_css: '/css/funnews/editor-styles.css',
            font_css: '/css/funnews/editor-font-styles.css',
            init_instance_callback: function (editor) {
                $(editor.getContainer()).find('button.tox-statusbar__wordcount').click();
            },
            setup: function (editor) {
                TinyMce.setupAutocompleteEntries(editor);

                editor.on('PastePreProcess', function (e) {
                    var max = 100000;
                    if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                        var max_override = document.getElementById(jQuery(editor).attr('id') + '-character-count').getAttribute('data-character-limit');
                        if (max_override) {
                            max = max_override;
                        }
                    }

                    var count = TinyMce.count_characters(jQuery(editor).attr('id'));
                    var paste_contents_length = e.content.length;

                    if (count + paste_contents_length > max) {
                        e.preventDefault();
                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Maximum allowed character is: " + max;
                        }
                    }
                });

                editor.on('Change', function (e) {
                    try {
                        if (typeof CreateCommunity.vars.form_changed !== 'undefined') {
                            CreateCommunity.vars.form_changed = true;
                        }
                    } catch (error) { }

                    try {
                        if (typeof CreatePost.vars.form_changed !== 'undefined') {
                            CreatePost.vars.form_changed = true;
                        }
                    } catch (error) { }
                });

                editor.on('KeyDown', function (e) {
                    var max = 30000;
                    if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                        var max_override = document.getElementById(jQuery(editor).attr('id') + '-character-count').getAttribute('data-character-limit');
                        if (max_override) {
                            max = max_override;
                        }
                    }

                    var count = TinyMce.count_characters(jQuery(editor).attr('id'));

                    if (count >= max) {
                        if (e.keyCode != 8 && e.keyCode != 46) {
                            tinymce.dom.Event.cancel(e);
                        }

                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Maximum allowed character is: " + max;
                        }
                    } else {
                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Characters: " + count + ' (Max: ' + max + ')';
                        }
                    }
                });
            }
        });
    };

    /**
     * Initial tinymce library - with additional buttons for page builder use
     *
     * @param int $height
     */
    this.initLibraryPageBuilder = function (height = 500) {
        tinymce.remove("textarea.tinymce-editor-page-builder");

        tinymce.init({
            selector: 'textarea.tinymce-editor-page-builder',
            height: height,
            max_height: 700,
            convert_urls: false,
            relative_urls: false,
            remove_script_host: false,
            link_url_preprocess: function (url) {
                // If it doesn't already have a protocol or is not a relative/internal/anchor
                if (
                    url &&
                    !url.match(/^(https?:|mailto:|tel:|\/|#)/i) &&
                    !url.match(/^[a-z]+:/i)
                ) {
                    return 'https://' + url;
                }
                return url;
            },
            link_default_protocol: 'https',
            link_assume_external_targets: true,
            resize: 'both',
            menubar: false,
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'charmap', 'anchor',
                'searchreplace', 'visualblocks', 'fullscreen',
                'insertdatetime', 'help', 'wordcount', 'media', 'autoresize',
                'image', 'directionality'
            ],
            paste_as_text: true,
            toolbar: 'styles | media | bold italic underline| alignleft aligncenter alignright alignjustify | link | bullist numlist | undo redo',
            media_url_resolver: (data) => {
                return new Promise((resolve) => {
                    if (data.url.indexOf('youtube') !== -1) {
                        var vid_id = FunMain.getParameterByName('v', data.url);
                        var embedHtml = '<iframe src="https://www.youtube.com/embed/' + vid_id +
                            '" width="400" height="400" ></iframe>';
                        resolve({ html: embedHtml });
                    } else {
                        resolve({ html: '' });
                    }
                });
            },
            content_css: '/css/funnews/editor-styles.css',
            font_css: '/css/funnews/editor-font-styles.css'
        });
    };

    /**
     * Initial tinymce library - with all plugins for admin use
     *
     * @param int $height
     */
    this.initLibraryAdmin = function (height = 500) {
        tinymce.remove("textarea.tinymce-editor-admin");

        tinymce.init({
            selector: 'textarea.tinymce-editor-admin',
            height: height,
            max_height: 700,
            convert_urls: false,
            relative_urls: false,
            remove_script_host: false,
            link_url_preprocess: function (url) {
                // If it doesn't already have a protocol or is not a relative/internal/anchor
                if (
                    url &&
                    !url.match(/^(https?:|mailto:|tel:|\/|#)/i) &&
                    !url.match(/^[a-z]+:/i)
                ) {
                    return 'https://' + url;
                }
                return url;
            },
            link_default_protocol: 'https',
            link_assume_external_targets: true,
            resize: 'both',
            menubar: false,
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'charmap', 'anchor',
                'searchreplace', 'visualblocks', 'fullscreen',
                'insertdatetime', 'help', 'wordcount', 'media', 'autoresize',
                'image'
            ],
            paste_as_text: true,
            toolbar: 'styles | media image | bold italic underline | link | bullist numlist | undo redo',
            media_url_resolver: (data) => {
                return new Promise((resolve) => {
                    if (data.url.indexOf('youtube') !== -1) {
                        var vid_id = FunMain.getParameterByName('v', data.url);
                        var embedHtml = '<iframe src="https://www.youtube.com/embed/' + vid_id +
                            '" width="400" height="400" ></iframe>';
                        resolve({ html: embedHtml });
                    } else {
                        resolve({ html: '' });
                    }
                });
            },
            content_css: '/css/funnews/editor-styles.css',
            font_css: '/css/funnews/editor-font-styles.css'
        });
    };

    /**
     * Initial tinymce library
     *
     * @param int $height
     */
    this.initLibraryBlank = function (height = 500) {
        tinymce.remove("textarea.tinymce-editor-blank");

        // Prevent Bootstrap dialog from blocking focusin
        document.addEventListener('focusin', (e) => {
            if (e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });

        tinymce.init({
            selector: 'textarea.tinymce-editor-blank',
            height: height,
            max_height: 700,
            media_alt_source: false,
            media_dimensions: false,
            media_poster: false,
            resize: 'both',
            menubar: false,
            plugins: [],
            toolbar: '',
            content_css: '/css/funnews/editor-styles.css',
            font_css: '/css/funnews/editor-font-styles.css',
            init_instance_callback: function (editor) {
                $(editor.getContainer()).find('button.tox-statusbar__wordcount').click();

                jQuery('textarea.tinymce-editor-blank').css({
                    'height': height,
                    'position': 'absolute',
                    'display': 'block'
                });
            },
            setup: function (editor) {
                TinyMce.setupAutocompleteEntries(editor);

                editor.on('PastePreProcess', function (e) {
                    var max = 100000;
                    if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                        var max_override = document.getElementById(jQuery(editor).attr('id') + '-character-count').getAttribute('data-character-limit');
                        if (max_override) {
                            max = max_override;
                        }
                    }

                    var count = TinyMce.count_characters(jQuery(editor).attr('id'));
                    var paste_contents_length = e.content.length;

                    if (count + paste_contents_length > max) {
                        e.preventDefault();
                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Maximum allowed character is: " + max;
                        }
                    }
                });

                editor.on('Change', function (e) {
                    tinymce.triggerSave();
                    jQuery('textarea.tinymce-editor-blank').trigger('input');

                    try {
                        if (typeof CreateCommunity.vars.form_changed !== 'undefined') {
                            CreateCommunity.vars.form_changed = true;
                        }
                    } catch (error) { }

                    try {
                        if (typeof CreatePost.vars.form_changed !== 'undefined') {
                            CreatePost.vars.form_changed = true;
                        }
                    } catch (error) { }
                });

                editor.on('KeyDown', function (e) {
                    var max = 30000;
                    if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                        var max_override = document.getElementById(jQuery(editor).attr('id') + '-character-count').getAttribute('data-character-limit');
                        if (max_override) {
                            max = max_override;
                        }
                    }

                    var count = TinyMce.count_characters(jQuery(editor).attr('id'));

                    if (count >= max) {
                        if (e.keyCode != 8 && e.keyCode != 46) {
                            tinymce.dom.Event.cancel(e);
                        }

                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Maximum allowed character is: " + max;
                        }
                    } else {
                        if (document.getElementById(jQuery(editor).attr('id') + '-character-count')) {
                            document.getElementById(jQuery(editor).attr('id') + '-character-count').innerHTML = "Characters: " + count + ' (Max: ' + max + ')';
                        }
                    }
                });
            }
        });
    };

    /**
     * Get character count for tinymce instance
     * 
     * @param string id - id attribute of tinymce instance
     * @return int
     */
    this.count_characters = function (id) {
        var body = tinymce.get(id).getBody();
        var content = tinymce.trim(body.innerText || body.textContent);
        return content.length;
    };

    /**
     * Get a list of autocomplete tag/username options
     * 
     * Notes:
     * Fun.social does not utilize hashtags
     * 
     * @param obj editor
     * 
     */
    this.setupAutocompleteEntries = function (editor) {
        var token = jQuery('meta[name="csrf-token"]').attr('content');
        var domain = window.location.hostname;

        if (
            domain != 'fun.social.local' &&
            domain != 'fun.social.perrill.dev' &&
            domain != 'fun.social' &&
            domain != 'fun.app.local' &&
            domain != 'fun.app.perrill.dev' &&
            domain != 'fun.app'
        ) {
            $.ajax({
                url: '/tag/getall',
                type: 'GET',
                data: {
                    _token: token
                },
                success: function (response) {
                    TinyMce.setupTinymceAutocomplete(JSON.parse(response), editor, 'tags', '#');
                }
            });
        }

        $.ajax({
            url: '/users/getall',
            type: 'GET',
            data: {
                _token: token
            },
            success: function (response) {
                TinyMce.setupTinymceAutocomplete(JSON.parse(response), editor, 'users', '@');
            }
        });
    };

    /**
     * Initialize tinymce autocomplete
     *
     * @param string autcomplete_items - json string of tags or usernames
     * @param obj editor
     * @param string type - type of autocomplete (tags/usernames)
     * @param string trigger_character - trigger character for autocomplete popup
     */
    this.setupTinymceAutocomplete = function (autcomplete_items, editor, type, trigger_character) {
        let onAction = (autocompleteApi, rng, value) => {
            editor.selection.setRng(rng);
            editor.insertContent(value);
            autocompleteApi.hide();
        };

        let getMatchedChars = (pattern) => {
            return autcomplete_items.filter(function (char) {
                return char.text.indexOf(pattern) !== -1;
            });
        };

        /* An autocompleter that allows you to insert special characters */
        editor.ui.registry.addAutocompleter(type, {
            trigger: trigger_character,
            minChars: 2,
            columns: 1,
            onAction: onAction,
            fetch: (pattern) => {
                return new Promise((resolve) => {
                    let results = getMatchedChars(pattern).map((char) => ({
                        type: 'autocompleteitem',
                        value: trigger_character + char.value + ' ',
                        text: char.text,
                        icon: trigger_character
                    }));
                    resolve(results);
                });
            }
        });
    }
}

jQuery(document).ready(function ($) {
    TinyMce.init();
});
